<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">版本管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>平台：</label>
          <el-select v-model="platform" placeholder="Select" style="width: 7em" @change='platformChange'>
            <el-option v-for="item in platformArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>渠道：</label>
          <el-select v-model="channel" placeholder="Select" style="width: 7em">
            <el-option v-for="item in channelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>版本状态：</label>
          <el-select v-model="isDel" placeholder="Select" style="width: 7em">
            <el-option v-for="item in isDelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>升级策略：</label>
          <el-select v-model="isAlive" placeholder="Select" style="width: 7em">
            <el-option v-for="item in isAliveArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="updateVersion(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
          <el-table-column property="version" label="版本号" v-if="checkColList.indexOf('版本号') > -1"></el-table-column>
          <el-table-column property="versionId" label="版本号id" v-if="checkColList.indexOf('版本号id') > -1"></el-table-column>
          <el-table-column property="appleId" label="苹果id" v-if="checkColList.indexOf('苹果id') > -1"></el-table-column>
          <el-table-column property="" label="平台" v-if="checkColList.indexOf('平台') > -1">
            <template #default="scope">
              <span>{{scope.row.platformType==1?'Android':scope.row.platformType==2?'iOS':scope.row.platformType==4?'鸿蒙':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="channel" label="渠道" v-if="checkColList.indexOf('渠道') > -1"></el-table-column>
          <el-table-column property="url" label="下载地址" v-if="checkColList.indexOf('下载地址') > -1" width="170"></el-table-column>
          <el-table-column property="descp" label="描述" v-if="checkColList.indexOf('描述') > -1" width="170"></el-table-column>
<!--          <el-table-column property="startTime" label="苹果支付开启时间" v-if="checkColList.indexOf('苹果支付开启时间') > -1" width="150"></el-table-column>-->
<!--          <el-table-column property="endTime" label="苹果支付结束时间" v-if="checkColList.indexOf('苹果支付结束时间') > -1" width="150"></el-table-column>-->
          <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1"></el-table-column>
          <el-table-column property="" label="当前版本状态" v-if="checkColList.indexOf('当前版本状态') > -1" width="170">
            <template #default="scope">
              <p>版本状态：{{scope.row.isDel==0?'正式版':scope.row.isDel==1?'审核版':''}}</p>
              <p>升级策略：{{scope.row.isAlive==0?'强制升级':scope.row.isAlive==1?'可选升级':''}}</p>
<!--              <p>支付方式：{{scope.row.payType==1?'苹果支付':scope.row.payType==2?'第三方支付':''}}</p>-->
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="140">
            <template #default="scope">
              <el-space direction="vertical" alignment="left">
                <el-button size="small" type="primary" @click="updateVersion(scope.$index, scope.row)">编辑</el-button>

                <el-button type="danger" size="small" v-if="scope.row.isDel==0" @click="upadteDel(scope.$index, scope.row, 1)" v-loading="scope.row.delLoading">设为审核版</el-button>
                <el-button type="danger" plain size="small"  v-if="scope.row.isDel==1" @click="upadteDel(scope.$index, scope.row, 0)" v-loading="scope.row.delLoading">设为正式版</el-button>
                <el-button type="success" size="small" v-if="scope.row.isAlive==1" @click="upadteAlive(scope.$index, scope.row, 0)" v-loading="scope.row.aliveLoading">设为强制升级</el-button>
                <el-button type="success" plain size="small" v-if="scope.row.isAlive==0" @click="upadteAlive(scope.$index, scope.row, 1)" v-loading="scope.row.aliveLoading">设为可选升级</el-button>
<!--                <el-button type="warning" size="small" v-if="scope.row.payType!=1" @click="updateApplePay(scope.$index,scope.row, 1)" v-loading="scope.row.payLoading">设为苹果支付</el-button>-->
<!--                <el-button type="warning" plain size="small" v-if="scope.row.payType==1" @click="updateApplePay(scope.$index, scope.row, 2)" v-loading="scope.row.payLoading">设为第三方支付</el-button>-->
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getFormData, postFormData} from "@/api/api";
import {
  getVersionPageList,
  updateVersionDefaultShare, getVersionListChannel, updateVersionDel, updateVersionAlive, updateVersionPayType, getAllChannelList
} from "@/api/url";
import Dialog from "@/assets/js/dialog";
import VersionDialog from "@/views/channel/components/VersionDialog";
import BtnGroup from '../../components/BtnGroup'

export default {
  name: "ChannelVersion",
  components: { BtnGroup },
  data() {
    return {

      //平台
      platformArray: [
        {label:'不限', value: -1},
        {label:'Android', value: 1},
        {label:'IOS', value: 2},
        {label:'鸿蒙', value: 4}
      ],
      platform: -1,

      //渠道
      channelArray: [
        { label: '不限', value: 0}
      ],
      channel: 0,

      listAll: [],
      iosList: [],
      androidList: [],
      harmonyList: [],

      //显示状态
      isDelArray: [
        { label: '不限', value: -1 },
        { label: '正式版', value: 0 },
        { label: '审核版', value: 1 }
      ],
      isDel: -1,

      //升级策略
      isAliveArray: [
        { label: '不限', value: -1 },
        { label: '强制升级', value: 0 },
        { label: '可选升级', value: 1 }
      ],
      isAlive: -1,


      //刷新组
      colList: ['创建时间', '版本号', '版本号id', '苹果id', '平台', '渠道', '下载地址', '描述', '苹果支付开启时间', '苹果支付结束时间', '备注', '当前版本状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,
    }
  },
  methods: {
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['platformType'] = this.platform;
      param['channelId'] = this.channel;
      param['isDel'] = this.isDel;
      param['isAlive'] = this.isAlive;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getVersionPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    //更新操作
    updateVersion(idx, row) {
      let _title = '';
      let versionForm = {
        versionId: 0,
        platformType: 1,
        appleId: 0
      }
      if(idx > -1) {
        _title = '编辑版本'
        versionForm = Object.assign({},row);
      }else {
        _title = '添加版本'
      }
      Dialog.open({
        title: _title,
        component: VersionDialog,
        data: {
          versionForm: versionForm,
          ids: idx,
          width: '600px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    //更新版本状态
    upadteDel(idx, row, state) {
      this.$messageBox.confirm('确定要将版本'+ (row.platformType == 1?'Android-':row.platformType == 2?'iOS-':'') + row.version + '设为' + (state ==0?'正式版':'审核版') +'?').then(()=>{
        this.pageDataList[idx]['delLoading'] = true;
        let param = {};
        param['id'] = row.id;
        param['isDel'] = state;
        postFormData(updateVersionDel, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.isDel = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['delLoading'] = false;
        }).catch(()=> {
          this.pageDataList[idx]['delLoading'] = false;
        })
      })
    },

    //更新升级策略
    upadteAlive(idx, row, state) {
      this.$messageBox.confirm('确定要将版本'+ (row.platformType == 1?'Android-':row.platformType == 2?'iOS-':'') + row.version + '设为' + (state ==0?'强制升级':'可选升级') +'?').then(()=>{
        this.pageDataList[idx]['aliveLoading'] = true;
        let param = {};
        param['id'] = row.id;
        param['isAlive'] = state;
        postFormData(updateVersionAlive, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.isAlive = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['aliveLoading'] = false;
        }).catch(()=> {
          this.pageDataList[idx]['aliveLoading'] = false;
        })
      })
    },

    //更新支付
    updateApplePay(idx, row, state) {
      this.$messageBox.confirm('确定要将版本'+ (row.platformType == 1?'Android-':row.platformType == 2?'iOS-':'') + row.version + '设为' + (state ==1?'苹果支付':'第三方支付') +'?').then(()=>{
        this.pageDataList[idx]['payLoading'] = true;
        let param = {};
        param['channelId'] = row.channelId;
        param['payType'] = state;
        // param['platformType'] = row.platformType;
        // param['channel'] = row.channel;
        postFormData(updateVersionPayType, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.payType = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['payLoading'] = false;
        }).catch(()=> {
          this.pageDataList[idx]['payLoading'] = false;
        })
      })
    },

    //获取渠道
    getChannel() {
      let _this = this
      let param = {};
      getFormData(getVersionListChannel, param).then(function(data){
        let dataList = data.data
        dataList.map(item => {
          let obj = {}
          if(item.platformType == 1) {
            obj.label = item.channel + '（Android）'
            obj.value = item.id
            _this.androidList.push(obj)
          }else if(item.platformType == 2) {
            obj.label = item.channel + '（IOS）'
            obj.value = item.id
            _this.iosList.push(obj)
          }else if(item.platformType == 4) {
            obj.label = item.channel + '（harmony）'
            obj.value = item.id
            _this.harmonyList.push(obj)
          }
        })
        _this.listAll = [..._this.androidList, ..._this.iosList, ... _this.harmonyList]
        _this.channelArray = [..._this.channelArray, ..._this.androidList, ..._this.iosList, ... _this.harmonyList]
      })
    },

    platformChange() {
      this.channelArray = [
        { label: '不限', value: 0}
      ]
      this.channel = 0
      if(this.platform == -1) {
        this.channelArray = [...this.channelArray, ...this.androidList, ...this.iosList]
      } else if (this.platform == 1) {
        this.channelArray = [...this.channelArray, ...this.androidList]
      } else if(this.platform == 2) {
        this.channelArray = [...this.channelArray, ...this.iosList]
      } else if(this.platform == 4) {
        this.channelArray = [...this.channelArray, ...this.harmonyList]
      }
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getChannel()
    this.getPage()

  }
}
</script>

<style scoped>

</style>
